import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: string[] = [];

  constructor(private router: Router) {}

  ngOnInit() {
    this.setBreadcrumb(this.router.url);

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.setBreadcrumb(this.router.url);
    });
  }

  private setBreadcrumb(url: string) {
    this.breadcrumbs = [];
    this.breadcrumbs = url.split('/').filter(u => u !== '');
  }

  goToUrl(item: string) {
    if (this.getClass(item) == 'url-active') {
      return;
    }
    let url = '';
    let indexOf = this.breadcrumbs.indexOf(item);
    let breadCopy = [...this.breadcrumbs].slice(0, indexOf + 1);
    breadCopy.forEach(element => {
      url = `${url}${element}/`;
    });
    url.length ? this.router.navigate([url]) : () => {};
  }

  getClass(item: string) {
    return this.breadcrumbs[this.breadcrumbs.length - 1] === item ? 'url-active' : 'url-inactive';
  }
}
